import {
  PrimaryTextColor,
  boldFont,
  drawerWidth,
  getRelativeFontSize,
  mediumFont,
  primaryLightGreen,
  primaryWhiteColor,
  primarygreenColor,
  primaryBlueColor,
} from "../../utils/styles";

const appHeaderStyles = {
  appHeader: {
    position: "fixed",
    width: `calc(100% - ${drawerWidth}px)`,
    height: "68px",
    bgcolor: "transparent",
    boxShadow: "none",
    zIndex: 99,
    right: 0,
    top: 0,
    borderBottom: "1px solid #E6E1DC",
    backgroundColor: "#FFFFFF",
    display: "flex",
    alignItems: "center",
  },
  appHeaderTitle: {
    ...boldFont,
  },
  menuMobile: {
    width: "100vw",
  },
  leftHeader: {
    display: "flex",
    alignItems: "center",
    height: "100%",
  },
  rightHeader: {
    height: "100%",
    display: "flex",
    paddingRight: "20px",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "10px",
    flexWrap: "nowrap",
  },
  topbarTitle: {
    ...boldFont,
    fontSize: getRelativeFontSize(2),
    color: PrimaryTextColor,
    marginLeft: "20px",
    textTransform: "capitalize",
  },
  logOutButton: {
    background: "#F9F0F4",
    borderRadius: "6px",
  },
  avtar: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    background: primaryLightGreen,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  avtarName: {
    color: "avtarName",
    ...mediumFont,
  },

  createButton: {
    background: "#F9F0F4",
    borderRadius: "8px",
    width: "130px",
    color: primaryBlueColor,
  },
  clockIn: {
    background: primarygreenColor,
    color: primaryBlueColor,
    width: "150px",
    "&:hover": {
      background: primarygreenColor,
    },
  },

  userDropdown: {
    width: "200px",
    position: "absolute",
    background: primaryWhiteColor,
    right: "0px",
    top: "11px",
    borderRadius: " 0px 0px 12px 12px",
    padding: "10px 15px",
    boxShadow: 2,
    zIndex: 10000,
  },
  userheader: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    juatidfyContent: "center",
  },

  userProfile: {
    width: "45px",
    height: "45px",
    borderRadius: "50%",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& img": {
      width: "100%",
      height: "auto",
    },
  },
  profile: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    overflow: "hidden",
    zIndex: 9,
    border: "4px solid #F9F0F4",
    display: "flex",
    alignItem: "center",
    justifyContent: "center",

    "& img": {
      width: "100%",
      height: "auto",
    },
  },

  userName: {
    fontSize: getRelativeFontSize(0),
    ...boldFont,
    letterSpacing: "1px",
    "& span":{
      textTransform:"capitalize",
    },
  },

  userRole: {
    fontSize: getRelativeFontSize(-2),
    color: PrimaryTextColor,
    ...mediumFont,
  },
  list: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "10px",
    cursor: "pointer",
  },

  listText: {
    display: "flex",
    gap: "5px",
    "& img": {
      width: "15px",
    },
    "& :hover": {
      color: primaryBlueColor,
    },
  },
  listName: {
    ...mediumFont,
    color: "#0C0E2E",
    fontSize: "0.875rem"
 
  },
  notificationsHeader: {
    ...boldFont,
    fontSize: getRelativeFontSize(10),
    color: "#000",
    lineHeight: "normal",
  },
  notificationsTime: {
    ...boldFont,
    fontSize: getRelativeFontSize(1),
    color: "#841C39",
    lineHeight: "normal",
  },
  notificationsname: {
    ...boldFont,
    fontSize: getRelativeFontSize(10),
    color: "#000",
    lineHeight: "normal",
  },
  notificationIcon:{
    display: "flex",
     alignItems: "center",
      justifyContent: "center", 
      height: "100%" 
  },
  notificationHeading:{
    fontWeight: "bold",
     fontSize: "18px",
    borderBottom: "1px solid #EEEFF2",
      padding:"15px 20px",
      position:"sticky",
      top:"0",
      zIndex:"10",
      background:"#fff"
  },
  reminderHeading:{
    fontWeight: "bold",
     fontSize: "16px",
      padding:"8px 20px",
      position:"sticky",
      top:"0",
      zIndex:"10",
      background:"#fff"
  },
  remCon:{
display: "flex",
 justifyContent: "space-between", 
 alignItems: "center",
  marginBottom: "8px"
  },
  notificationContainer:{
    width: "500px", padding: "15px", backgroundColor: "white", borderRadius: "8px", boxShadow: 3
  }

} as const;

export default appHeaderStyles;
